import React from 'react';
import './OnboardingStepper.scss';

const OnboardingStepper = ({ steps, currentStep, skippedSteps = [], onStepClick }) => {
  return (
    <div className="ob-stepper-bar">
      {steps.map((step, index) => {
        const isDone = index < currentStep && !skippedSteps.includes(index);
        const isActive = index === currentStep;
        const isSkipped = skippedSteps.includes(index);
        const isClickable = !!onStepClick && !isSkipped && !isActive;
        return (
          <React.Fragment key={index}>
            <div
              className={`ob-step-node${isDone ? ' done' : ''}${isActive ? ' active' : ''}${isSkipped ? ' skipped' : ''}${isClickable ? ' clickable' : ''}`}
              onClick={isClickable ? () => onStepClick(index) : undefined}
            >
              <span className="ob-step-num">Step {index + 1}</span>
              <span className="ob-step-lbl">{step}</span>
            </div>
            {index < steps.length - 1 && (
              <div className="ob-step-arrow">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <polyline points="9 18 15 12 9 6" />
                </svg>
              </div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default OnboardingStepper;
